import { ComplianceCaseStatus } from "../../graphql/supergraphEnums";
import { LandingUIState, UserAccessibleComplianceCase } from "../types";

export const findRefreshUIState = (
  isTransitioning: boolean,
  complianceCase?: UserAccessibleComplianceCase | null,
): LandingUIState => {
  if (!complianceCase) {
    return LandingUIState.CaseNotFound;
  }
  if (complianceCase?.status === ComplianceCaseStatus.NotReady) {
    if (!complianceCase?.subStatus) {
      return LandingUIState.Confirmation;
    }
    if (!isTransitioning) {
      return LandingUIState.Compliance;
    }
  }
  return LandingUIState.Completion;
};
